function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "4.4c\\u2013-User-\\u2013-Library-\\u2013-Default-Overlay-option-2-Copy",
  transform: "translate(-897.000000, -642.000000)",
  fill: "#656363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(117.000000, 136.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(28.000000, 38.000000)"
}, React.createElement("g", {
  id: "Video-Badge",
  transform: "translate(752.000000, 468.000000)"
}, React.createElement("path", {
  d: "M11.5961669,0 L2.12286808,0 C0.950440413,0 0,0.916254465 0,2.04651163 L0,8.95348837 C0,10.0837455 0.950440413,11 2.12286808,11 L11.5961669,11 C12.1591865,11 12.6991463,10.784386 13.0972613,10.4005906 C13.4953763,10.0167952 13.719035,9.496257 13.719035,8.95348837 L13.719035,7.93023256 L16.5052993,9.74651163 C16.7694112,9.92647371 17.0841119,10.0246265 17.4075182,10.027907 C17.6673057,10.0330439 17.9238054,9.97122547 18.1505221,9.84883721 C18.6765586,9.58786362 19.0050762,9.06332711 18.9996693,8.49302326 L18.9996693,2.48139535 C19.011505,1.92978464 18.7048672,1.41739659 18.2035938,1.15116279 C17.712493,0.871593721 17.1025435,0.871593721 16.6114427,1.15116279 L13.719035,2.7372093 L13.719035,2.04651163 C13.719035,1.503743 13.4953763,0.983204757 13.0972613,0.599409378 C12.6991463,0.215613999 12.1591865,0 11.5961669,0 Z M12.6576009,8.95348837 C12.6649737,9.2269897 12.5555136,9.4914089 12.3548355,9.68486883 C12.1541575,9.87832876 11.8798727,9.98385175 11.5961669,9.97674419 L2.12286808,9.97674419 C1.83916227,9.98385175 1.56487745,9.87832876 1.36419942,9.68486883 C1.1635214,9.4914089 1.05406129,9.2269897 1.06143404,8.95348837 L1.06143404,2.04651163 C1.05406129,1.7730103 1.1635214,1.5085911 1.36419942,1.31513117 C1.56487745,1.12167124 1.83916227,1.01614825 2.12286808,1.02325581 L11.5961669,1.02325581 C11.8798727,1.01614825 12.1541575,1.12167124 12.3548355,1.31513117 C12.5555136,1.5085911 12.6649737,1.7730103 12.6576009,2.04651163 L12.6576009,8.95348837 Z M17.1421597,2.02093023 C17.3063642,1.92953671 17.5086723,1.92953671 17.6728768,2.02093023 C17.8386744,2.1192116 17.9392666,2.29376489 17.9382353,2.48139535 L17.9382353,8.49302326 C17.9463766,8.68926746 17.8312059,8.87095006 17.6463409,8.95348837 C17.4737944,9.03542206 17.2679238,9.01557549 17.1156239,8.90232558 L13.719035,6.67674419 L13.719035,3.93953488 L17.1421597,2.02093023 Z",
  id: "Shape"
}))))));

var SvgVideoBadge = function SvgVideoBadge(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "11px",
    viewBox: "0 0 19 11",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideoBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video_badge.1c138897.svg";
export { ForwardRef as ReactComponent };